import { render, staticRenderFns } from "./amacbazlistratejikplandegerlendirmetablosu.vue?vue&type=template&id=c95220fe"
import script from "./amacbazlistratejikplandegerlendirmetablosu.vue?vue&type=script&lang=js"
export * from "./amacbazlistratejikplandegerlendirmetablosu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports